<!-- Header -->
<div class="header center header-color-dark transparent-dark">
  <div class="container">
    <div class="header-logo">
      <h3 class="font-family-syne letter-spacing-1">
        <a routerLink="/">Komo</a>
      </h3>
    </div>

    <!-- Menu -->
    <div class="header-menu" [ngClass]="{ 'show': isMenuOpen }">
      <ul class="nav">
        <!-- Dropdown Item -->
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(0)">Home</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 0 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/">Startup Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-two">Design Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-three">Corporate Business</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-four">Consulting</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-five">Digital Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-six">SEO Agency</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 0 }" (click)="toggleDropdown(0)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(1)">Pages</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 1 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/about-us">About Us</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/our-team">Our Team</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/team-details">Team Details</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/testimonials">Testimonials</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/pricing-table">Pricing Table</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/404-page">404 Error Page</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/coming-soon">Coming Soon</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 1 }" (click)="toggleDropdown(1)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(2)">Services</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 2 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/services">Services</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/service-two">Service Two</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/service-three">Service Three</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/service-four">Service Four</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 2 }" (click)="toggleDropdown(2)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(3)">Portfolio</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 3 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-two-column">Portfolio Two Columns</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-three-column">Portfolio Three Columns</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-four-column">Portfolio Four Columns</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-detail">Portfolio Details</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 3 }" (click)="toggleDropdown(3)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(4)">Blogs</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 4 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-grid">Blog Grid</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-standard">Blog Standard</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 4 }" (click)="toggleDropdown(4)"></a>
        </li>

        <li class="nav-item" (click)="closeMenu()">
          <a class="nav-link" routerLink="/contact">Contact Us</a>
        </li>
      </ul>
    </div>

    <!-- Social Icons -->
    <div class="header-menu-extra">
      <ul class="list-inline-sm">
        <li><a href="/"><i class="bi bi-facebook"></i></a></li>
        <li><a href="/"><i class="bi bi-twitter-x"></i></a></li>
        <li><a href="/"><i class="bi bi-linkedin"></i></a></li>
      </ul>
    </div>

    <!-- Menu Toggle -->
    <button class="header-toggle" [class.toggle-close]="isMenuOpen" (click)="toggleMenu()">
      <span></span>
    </button>
  </div>
</div>
<!-- end Header -->

<!-- 404 Page section -->
<div class="section-fullscreen">
        <div class="container">
            <div class="position-middle">
                <div class="row g-4">
                    <div class="col-12">
                        <h1 class="display-2 fw-bold text-gradient-6 font-family-syne line-height-160">Oops! Page Not Found.</h1>
                        <h5 class="fw-light text-dark-05">The page you're looking for might have been moved, deleted, or never existed.</h5>
                        <a class="button button-lg button-rounded button-font-2 button-gradient-6 mt-4" routerLink="/"><i class="fas fa-home"></i><span>Go home page</span></a>
                    </div>
                </div><!-- end row -->
            </div><!-- end position-middle -->
        </div><!-- end container -->
    </div>
<!-- end 404 Page section -->

<!-- Parallax section -->
<div class="section-xl bg-image parallax" style="background-image: url('assets/images/backgrounds/parallax-bg.jpg');">
    <div class="bg-dark-03">
        <div class="container text-center">
            <div class="row g-4">
                <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                    <h2 class="display-4 font-family-syne fw-medium">Ready to Elevate Your IT Strategy?</h2>
                    <p>Maecenas nec odio et ante tincidunt tempus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt.</p>
                    <a class="button button-lg button-radius button-outline-white mt-4" routerLink="/contact">Call Us</a>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</div>
<!-- end Parallax section -->